<template>
  <div class="toolbar">
    <div class="left">
      <div class="title">
        <span v-if="!!editItem && !editMode" @click="enableEditMode">
          {{ title }}
          <LmTooltip> Click to edit </LmTooltip>
        </span>

        <q-input
          v-else
          ref="input"
          v-model.trim="newTitle"
          :rules="[val => !!val || 'Required']"
          label="Title"
          color="white"
          dark
          autogrow
          outlined
          stack-label
          hide-bottom-space
          @blur="disableEditMode"
          @hook:mounted="changeQuasarErrorColor"
        />
      </div>
      <div v-if="!!editItem && !editMode" class="info">Created by: {{ editItem.created_by.name }}</div>
    </div>
    <div class="right">
      <div v-if="!!editItem" class="assignees">
        <div v-for="assignee of assignees" :key="assignee.id" :style="{ background: assignee.color }" class="assignee">
          {{
            assignee.name
              .split(' ')[0]
              .slice(0, 1)
              .toUpperCase()
          }}
          <template v-if="assignee.name.split(' ').length > 1">
            {{
              assignee.name
                .split(' ')[1]
                .slice(0, 1)
                .toUpperCase()
            }}
          </template>
          <LmTooltip> {{ assignee.name }} </LmTooltip>
        </div>
      </div>
      <q-btn flat round icon="fal fa-times" @click="$emit('close')" />
    </div>
  </div>
</template>

<script>
import { colors } from 'quasar'
import { mapState } from 'vuex'

export default {
  props: {
    editItem: Object,
    title: String
  },

  data: () => ({
    editMode: false,
    newTitle: ''
  }),

  computed: {
    ...mapState('todo-modal', ['selectedTemplate']),

    assignees() {
      if (!this.editItem.owners.length) return []
      return this.editItem.owners
    }
  },

  watch: {
    newTitle(val) {
      this.$emit('update:title', val)
    },

    selectedTemplate(template) {
      this.newTitle = template.title
    }
  },

  created() {
    if (!this.editItem) {
      this.editMode = true
      this.$nextTick(() => this.$refs.input.focus())
    } else this.newTitle = this.editItem.title
  },

  methods: {
    enableEditMode() {
      this.editMode = true
      this.$nextTick(() => this.$refs.input.focus())
    },

    disableEditMode() {
      if (!this.editItem || !this.title) return
      this.editMode = false
    },

    changeQuasarErrorColor() {
      colors.setBrand('negative', '#000', this.$refs.input.$el)
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/styles/stylus/custom-variables'

  .toolbar {
    display grid
    grid-template-columns 1fr auto
    align-items start
    gap 15px
    background #65b5a5
    min-height 80px
    color white
    padding 23px 26px
    word-break break-word

    > .left {
      > .title {
        font-size 1rem
        font-weight 500
        &[contenteditable="true"] {
          padding 5px
          border 1px solid white
        }
      }
      > .info {
        font-size 12px
        color #e8ecf7
      }
    }

    > .right {
      display grid
      grid-template-columns 1fr auto
      align-items center
      gap 15px

      > button {
        justify-self end
      }
    }

    .assignees {
      display grid
      grid-template-columns repeat(auto-fit, 25px)
      justify-content end
      max-width 450px
      user-select none

      .assignee {
        position relative
        border-radius 50%
        width 35px
        height 35px
        display flex
        justify-content center
        align-items center
        border 1px solid white
        color white
        font-weight 500
        font-size 0.75rem
        cursor pointer
        transition transform .2s ease-in-out
        animation fadeInScaleIn 350ms ease-in-out both;

        for num in (1..5) {
          &:nth-child({num}) {
            animation-delay: 100ms * num;
          }
        }

        &:hover {
          z-index 1
          transform translateY(-4px)
        }

      }
    }
  }

@keyframes fadeInScaleIn {
  from {
    opacity 0
    transform scale(0.6) translateY(-8px)
  }

  to {
    opacity 1
  }
}
</style>
